(function () {
  'use strict';

  window.__custoArmorTabFixVersion = '2026-07-17-v3';

  if (window.__custoArmorTabFixBound) {
    return;
  }

  window.__custoArmorTabFixBound = true;
  window.__custoArmorTabFixClickCount = 0;

  var rootSelector =
    '.product_tabsection.fordesktop_productbelow';

  var tabSelector =
    rootSelector +
    ' .producttab_fordesktop ul.tabs a[href="#tab-11"], ' +
    rootSelector +
    ' .producttab_fordesktop ul.tabs a[href="#tab-22"]';

  var activeTabBar = null;
  var savedTabTop = null;
  var restoreUntil = 0;
  var animationFrame = null;

  var originalHtmlScrollBehavior = '';
  var originalBodyScrollBehavior = '';

  function findTab(event) {
    if (
      window.innerWidth < 750 ||
      !event.target ||
      typeof event.target.closest !== 'function'
    ) {
      return null;
    }

    return event.target.closest(tabSelector);
  }

  function findTabBar(tab) {
    var root = tab.closest(rootSelector);

    if (!root) {
      return null;
    }

    return root.querySelector(
      '.producttab_fordesktop ul.tabs'
    );
  }

  function disableSmoothScrolling() {
    var html = document.documentElement;
    var body = document.body;

    originalHtmlScrollBehavior =
      html.style.getPropertyValue('scroll-behavior');

    originalBodyScrollBehavior = body
      ? body.style.getPropertyValue('scroll-behavior')
      : '';

    html.style.setProperty(
      'scroll-behavior',
      'auto',
      'important'
    );

    if (body) {
      body.style.setProperty(
        'scroll-behavior',
        'auto',
        'important'
      );
    }
  }

  function restoreSmoothScrolling() {
    var html = document.documentElement;
    var body = document.body;

    if (originalHtmlScrollBehavior) {
      html.style.setProperty(
        'scroll-behavior',
        originalHtmlScrollBehavior
      );
    } else {
      html.style.removeProperty('scroll-behavior');
    }

    if (!body) {
      return;
    }

    if (originalBodyScrollBehavior) {
      body.style.setProperty(
        'scroll-behavior',
        originalBodyScrollBehavior
      );
    } else {
      body.style.removeProperty('scroll-behavior');
    }
  }

  function removeTabHash() {
    var hash = window.location.hash;

    if (hash !== '#tab-11' && hash !== '#tab-22') {
      return;
    }

    window.history.replaceState(
      window.history.state,
      '',
      window.location.pathname +
        window.location.search
    );
  }

  function preserveTabPosition() {
    if (
      activeTabBar &&
      activeTabBar.isConnected &&
      savedTabTop !== null
    ) {
      var currentTop =
        activeTabBar.getBoundingClientRect().top;

      var movement = currentTop - savedTabTop;

      if (Math.abs(movement) > 0.5) {
        window.scrollBy({
          top: movement,
          left: 0,
          behavior: 'auto'
        });
      }
    }

    removeTabHash();

    if (performance.now() < restoreUntil) {
      animationFrame =
        window.requestAnimationFrame(
          preserveTabPosition
        );

      return;
    }

    restoreSmoothScrolling();

    activeTabBar = null;
    savedTabTop = null;
    animationFrame = null;
  }

  function savePosition(tab) {
    activeTabBar = findTabBar(tab);

    if (!activeTabBar) {
      return false;
    }

    savedTabTop =
      activeTabBar.getBoundingClientRect().top;

    return true;
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      var tab = findTab(event);

      if (tab) {
        savePosition(tab);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var tab = findTab(event);

      if (!tab) {
        return;
      }

      if (!activeTabBar || savedTabTop === null) {
        if (!savePosition(tab)) {
          return;
        }
      }

      window.__custoArmorTabFixClickCount += 1;

      /*
       * Stop native #tab-11 / #tab-22 navigation.
       * Do not stop propagation because the theme still
       * needs to switch the visible tab content.
       */
      event.preventDefault();

      disableSmoothScrolling();

      if (animationFrame !== null) {
        window.cancelAnimationFrame(animationFrame);
      }

      restoreUntil = performance.now() + 2500;

      animationFrame =
        window.requestAnimationFrame(
          preserveTabPosition
        );
    },
    true
  );
})();